export default "__VITE_ASSET__BwAn5HGo__"